import React from 'react';
import { Link } from 'react-router-dom';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';
import { isAuthenticated } from '../services/auth';
import './HelpPage.css';

const helpUrl = process.env.REACT_APP_HELP_URL || '';

function HelpPage() {
  const { tenantCode, tenantPath } = useTenantFromUrl();
  const backTo = isAuthenticated() && tenantCode ? tenantPath('/dashboard') : '/login';
  const backLabel = isAuthenticated() ? 'Back to app' : 'Back to login';

  return (
    <div className="help-page">
      <div className="help-page-card">
        <h1 className="help-page-title">Help</h1>
        {helpUrl ? (
          <p className="help-page-lead">
            Documentation and guides are available at the link below.
          </p>
        ) : (
          <p className="help-page-lead">
            In-app help and searchable documentation are not available yet. For product questions or access issues,
            contact your organization administrator.
          </p>
        )}
        {helpUrl && (
          <p className="help-page-cta">
            <a href={helpUrl} className="link-nav" target="_blank" rel="noopener noreferrer">
              Open help and documentation
            </a>
          </p>
        )}
        <p className="help-page-back">
          <Link to={backTo} className="link-nav">
            {backLabel}
          </Link>
        </p>
      </div>
    </div>
  );
}

export default HelpPage;
